import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const TRANSLATION_KEY = 'Instruction.string';

const CONTENT =
  'A power supply generates the electrical current that can be used to power lab equipment. It is commonly used to provide the current that is applied to a gel during gel electrophoresis. You can set the amount of voltage (or current) you want using the arrows on the left. You can set how long the power supply should run using the arrows on the right.';

export function Instruction(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const INSTRUCTION = t(TRANSLATION_KEY);

  return <span className={props.className}>{INSTRUCTION}</span>;
}

Instruction.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};

Instruction.defaultProps = {};
